import { useEffect } from 'react';
import useWebSocket from 'react-use-websocket';
import { useQueryClient } from '@tanstack/react-query';
import { WebsocketMessageData, WebsocketMessagesTypes } from '../types/websockets';
import { useUserContext } from '../context/user';

// постоянный слушатель точного счётчика непрочитанных
// смонтирован выше роутов чтобы CLAIM_UNREAD_COUNT не терялся при навигации список заявка
// пишет число прямо в кэш не дёргая рефетч списка
export const ClaimUnreadSocketListener = () => {
    const queryClient = useQueryClient();
    const { userUuid } = useUserContext();

    const token = localStorage.getItem('xAuthToken');
    // подключаемся только когда залогинены
    const socketUrl = userUuid && token
        ? `${process.env.REACT_APP_WEBSOCKET_URL}chats/?jwt=${token}`
        : null;

    // share общий сокет с UserWebsocket списка и заявки отдельного соединения не открываем
    const { lastMessage } = useWebSocket(socketUrl, {
        share: true,
        shouldReconnect: () => true,
        reconnectAttempts: 1000,
        reconnectInterval: 3000,
    });

    useEffect(() => {
        if (!lastMessage) return;

        let msg: WebsocketMessageData;
        try {
            msg = JSON.parse(lastMessage.data);
        } catch {
            return;
        }

        if (msg?.msg_type !== WebsocketMessagesTypes.CLAIM_UNREAD_COUNT) return;

        const claimPk = msg.data?.claim_pk;
        if (claimPk == null) return;
        const count = +msg.data.unread_messages;

        // точное число в кэш списка заявок
        queryClient.setQueriesData({ queryKey: ['travelClaims'] }, (oldData: any) => {
            if (!oldData?.results) return oldData;
            return {
                ...oldData,
                results: oldData.results.map((item: any) =>
                    String(item.pk) === String(claimPk) ? { ...item, unread_messages: count } : item
                ),
            };
        });
        // и в открытую заявку
        queryClient.setQueryData(['travelClaim'], (oldData: any) =>
            oldData && String(oldData.pk) === String(claimPk) ? { ...oldData, unread_messages: count } : oldData
        );
    }, [lastMessage, queryClient]);

    return null;
};
